__turbopack_context__.v({
  "boxContainer": "ProductLineItem-module-scss-module__pN186W__boxContainer",
  "checked": "ProductLineItem-module-scss-module__pN186W__checked",
  "content": "ProductLineItem-module-scss-module__pN186W__content",
  "copy": "ProductLineItem-module-scss-module__pN186W__copy",
  "heading": "ProductLineItem-module-scss-module__pN186W__heading",
  "hiddenCheckbox": "ProductLineItem-module-scss-module__pN186W__hiddenCheckbox",
  "imageContainer": "ProductLineItem-module-scss-module__pN186W__imageContainer",
  "imageContainer34": "ProductLineItem-module-scss-module__pN186W__imageContainer34",
  "link": "ProductLineItem-module-scss-module__pN186W__link",
});
